/* @flow */
import React from 'react';
import Spinkit from 'react-spinkit';
import _cx from 'classnames/bind';

import s from './Spinner.styl';
const cx = _cx.bind(s);

type SpinnerProps = {
  className?: string,
};
export const Spinner = (props: SpinnerProps) => {
  const { className, ...childProps } = props;
  return (
    <div data-cy={'spinner'} className={cx(className, 'Spinner')} {...childProps}>
      <Spinkit name='three-bounce' fadeIn='none' />
    </div>
  );
};

export const Pulse = (props: ?Object) => (
  <div {...props}>
    <Spinkit name='pulse' fadeIn='none' />
  </div>
);

type CircleProps = {
  className?: string,
};
export const Circle = (props: CircleProps) => {
  const { className, ...childProps } = props;
  return (
    <span className={cx(className, 'Circle')} {...childProps}>
      <span className={s.inner}></span>
    </span>
  );
};



// WEBPACK FOOTER //
// ./web_modules/trustar/components/Spinner.js